﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IDirectionalLightNode } from '../kb3d-models';
import { KbVector } from '../primitives/kb-vector';
import { Token } from '../token';
import { ShadowLightNode } from './shadow-light-node';

@Kb3dModel({
    token: Token.DirectionalLightNode,
})
export class DirectionalLightNode extends ShadowLightNode implements IDirectionalLightNode {
    constructor() {
        super();
    }

    public direction: KbVector;
}
